import React, { lazy, Suspense } from 'react'
import { observer } from 'mobx-react'

import { useStores } from 'stores'
import ContentLoader from 'common/ContentLoader'

const createDynamicWebshopComponent = componentPath => {
  // Lazy load both versions
  const V1Component = lazy(() => import(`components/Webshop/${componentPath}`))
  const V2Component = lazy(() => import(`components/WebshopV2/${componentPath}`))

  return observer(props => {
    const { authStore } = useStores()

    const {
      AppSession: { session },
    } = authStore

    const ComponentToRender = session.useLegacyWebshop ? V1Component : V2Component

    return (
      <Suspense fallback={<ContentLoader show={true} className="align-items-start pt-6" />}>
        <ComponentToRender {...props} />
      </Suspense>
    )
  })
}

export const WebshopHome = createDynamicWebshopComponent('WebshopHome')
export const WebshopCart = createDynamicWebshopComponent('WebshopCart')
export const WebshopCatalog = createDynamicWebshopComponent('WebshopCatalog')
export const WebshopFavourites = createDynamicWebshopComponent('WebshopFavourites')
export const WebshopProductDetail = createDynamicWebshopComponent('WebshopProductDetail')
export const WebshopSearch = createDynamicWebshopComponent('WebshopSearch')
export const WebshopLayout = createDynamicWebshopComponent('WebshopLayout')
export const WebshopCatalogLayout = createDynamicWebshopComponent('WebshopCatalogLayout')
